export default __webpack_public_path__ + "static/media/team-member-2.fa636c74.png";